// extracted by mini-css-extract-plugin
module.exports = {"container":"Switcher_container__2d1ue","pointWrapper":"Switcher_pointWrapper__2OWlP","point":"Switcher_point__2zlWo","selected":"Switcher_selected__2dCj1"};